import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import keycloak from './keycloak/keycloak';
import StoreProvider from './stores/stores';
import 'leaflet/dist/leaflet.css';

const TOKEN_REFRESH_INTERVAL_MS = 30000;
const TOKEN_MIN_VALIDITY_SEC = 60;

const Root = () => {
  const [keycloakProfile, setKeycloakProfile] = useState(null);
  const [keycloakReady, setKeycloakReady] = useState(false);

  useEffect(() => {
    let refreshInterval = null;

    keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
    }).then(authenticated => {
      if (authenticated) {
        localStorage.setItem('token', keycloak.token);

        refreshInterval = setInterval(() => {
          keycloak.updateToken(TOKEN_MIN_VALIDITY_SEC).then(refreshed => {
            if (refreshed) localStorage.setItem('token', keycloak.token);
          }).catch(() => {
            localStorage.removeItem('token');
            keycloak.logout();
          });
        }, TOKEN_REFRESH_INTERVAL_MS);

        keycloak.loadUserProfile().then(profile => {
          setKeycloakProfile(profile);
          setKeycloakReady(true);
        });
      }
    }).catch(() => {
      console.error('Keycloak init failed');
    });

    return () => {
      if (refreshInterval) clearInterval(refreshInterval);
    };
  }, []);

  if (!keycloakReady) return null;

  return (
    <StoreProvider>
      <App keycloakProfile={keycloakProfile} />
    </StoreProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
